import { useCallback } from 'react';

import { useDeleteAmendment } from '@xemplo/amendment-query';
import { usePromptDialog } from '@xemplo/prompt-dialog';
import { safeCallAsync } from '@xemplo/safe-call';
import { ToastType, useToast } from '@xemplo/toast';

export interface UseRemoveAmendmentPromptProps {
  amendmentId: string;
  onSuccess?: () => void;
}

export const useRemoveAmendment = (props: UseRemoveAmendmentPromptProps) => {
  const { amendmentId, onSuccess } = props;
  const { addToast } = useToast();
  const { mutateAsync: deleteAmendment } = useDeleteAmendment({ amendmentId });
  const promptDialog = usePromptDialog({ id: 'remove-amendment-prompt' });

  const handleConfirm = useCallback(async () => {
    const [, error] = await safeCallAsync(deleteAmendment());
    if (error) return;
    addToast({ text: 'Amendment deleted', type: ToastType.Confirmation });
    promptDialog.closeDialog();
    onSuccess?.();
  }, [deleteAmendment, addToast, promptDialog, onSuccess]);

  const handleCancel = useCallback(() => {
    promptDialog.closeDialog();
  }, [promptDialog]);

  return { promptDialog, handleConfirm, handleCancel };
};
